import * as Yup from "yup";
import { specialCharactersNotAllowedValidation } from "../../../helpers/constants/commonValidationSchemaUtils";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import {
  CreateBulkTransferFormKey,
  TransferProgramFormKey,
  TransferSearchParticipantFormKey,
  transferTypeKey,
} from "./Models";

export const BulkTransferSearchParticipantSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [TransferSearchParticipantFormKey.transferType]: Yup.string().default(""),
    [TransferSearchParticipantFormKey.deliveryCountry]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [TransferSearchParticipantFormKey.nextView]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [TransferSearchParticipantFormKey.productLine]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [TransferSearchParticipantFormKey.programTemplate]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [TransferSearchParticipantFormKey.clientFilter]: Yup.string().default(""),
    [TransferSearchParticipantFormKey.client]: Yup.string().default(""),
  });

export const TransferProgramFormSchema = (
  commonValidationMessages: KeyValueMap,
  transferType: string,
) => {
  const isChangeCountry = transferType === transferTypeKey.changeCountry;
  const isChangeProgram = transferType === transferTypeKey.changeProgram;

  return Yup.object().shape({
    [TransferProgramFormKey.deliveryOffice]: isChangeCountry
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string().default(""),

    [TransferProgramFormKey.destinationCountry]: isChangeCountry
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string(),

    [TransferProgramFormKey.nextLanguage]: isChangeCountry
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string().default(""),

    [TransferProgramFormKey.compatibleProgramTemplate]: isChangeProgram
      ? Yup.string().required(commonValidationMessages.requiredValidation)
      : Yup.string().default(""),
  });
};

export const CreateBulkTransferSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [CreateBulkTransferFormKey.bulkProcessName]:
      specialCharactersNotAllowedValidation(
        commonValidationMessages.requiredValidation,
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ).default(""),
  });
